import React from 'react';
import './LoadingOverlay.css';

/**
 * Full-screen busy overlay.
 *
 * Renders a spinner AND dims ("grays out") the page behind it, so the user gets
 * unmistakable feedback while a submit or a page transition is in flight.
 *
 * Usage: render conditionally from the caller, e.g.
 *   {submitting && <LoadingOverlay label={t('auth.signingIn', 'Signing in…')} />}
 *
 * Styling uses design tokens from src/styles/globals.css, so it is dark-mode
 * aware and must not introduce hardcoded colors.
 */
export default function LoadingOverlay({ label, className = '' }) {
  return (
    <div
      className={`lc-loading-overlay ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="lc-loading-overlay__panel">
        <div className="lc-loading-overlay__spinner" aria-hidden="true" />
        {label ? <p className="lc-loading-overlay__label">{label}</p> : null}
      </div>
    </div>
  );
}
